import { OPTIMIZELY_FEATURE_FLAGS_KEYS, PARTNERS_SCHEDULE_LIST_V2 } from 'components/Optimizely/Optimizely.features';

import { useIsFeatureEnabled } from './useIsFeatureEnabled';

export function useIsScheduleListV2Enabled() {
  return useIsFeatureEnabled(OPTIMIZELY_FEATURE_FLAGS_KEYS[PARTNERS_SCHEDULE_LIST_V2]);
}
